import { Component, OnInit, OnDestroy } from '@angular/core';
import { Program }           from './../../models/program/program';
import { ProgramService } from './../../shared/services/program.service';
import { ISubscription }                  from 'rxjs/Subscription';
import { EditionService } from '../../shared/services/edition.service';
import { BatchResponse } from '../../models/program/batch-response';
import { BatchCommitInfo } from '../../models/program/batch-commit-info';
import { NewAndExistingUsers } from '../../models/program/new-and-existing-users';

@Component({
  selector: 'app-program-list',
  templateUrl: './program-list.component.html',
  styleUrls: ['./program-list.component.less']
})

export class ProgramListComponent implements OnInit, OnDestroy {
  public programs: Program[];
  public currentPrograms: Program[];
  public retiredPrograms: Program[];
  public programsSub: ISubscription;
  public editionSub: ISubscription;
  public stateObj = {
    categoryId: 0,
    categoryType: 'edition'
  }
  public attachedSubscriptionPlan: boolean;
  public batchResponse: BatchResponse;
  public commitInfoForSubscriptionSettings: BatchCommitInfo;
  public newAndExistingUsersForSubscriptionSettings: NewAndExistingUsers;
  public showUsersAdd: boolean;
  public showRetiredPrograms: boolean = false;

  constructor(
    private programService: ProgramService,
    private editionService: EditionService,
  ) { }

  private subscribeToGetPrograms(): void {
    this.programsSub = this.programService
        .getPrograms()
        .subscribe(programs => {
          this.programs = programs;
          this.currentPrograms = programs.filter(program => !program.is_retired);
          this.retiredPrograms = programs.filter(program => program.is_retired);
        });
  }

  private subscribeToGetEditionDetails(): void {
    this.editionSub = this.editionService
        .getEdition()
        .subscribe(edition => {
          this.attachedSubscriptionPlan = edition.attached_subscription_plan;
        });
  }

  public batchWatch(batchResponse: BatchResponse) {
    this.batchResponse = batchResponse;
    console.log('batch:', this.batchResponse);
  }

  public resetData(): void {
    this.newAndExistingUsersForSubscriptionSettings = null;
    this.showUsersAdd = false;
    this.batchResponse = null;
    this.commitInfoForSubscriptionSettings = null;
  }

  public loadSettingsFromBatch(batchCommitInfo: BatchCommitInfo): void {
    this.showUsersAdd = false;
    this.commitInfoForSubscriptionSettings = batchCommitInfo;
  }

  public loadSettingsFromNewAndExistingList(newAndExistingUsers: NewAndExistingUsers): void {
    this.showUsersAdd = false;
    this.newAndExistingUsersForSubscriptionSettings = newAndExistingUsers;
  }

  public ngOnDestroy(): void {
    this.programsSub.unsubscribe();
    this.editionSub.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscribeToGetPrograms();
    this.subscribeToGetEditionDetails();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program-list.component.ts